import React from 'react';
import '../../assets/scss/globalComponent.scss';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className={'flex-col justify-center align-center'}>
      <div className="grid flex-full align-center gap-48 py-56 flex-col ">
        <div className="text-center tab:text-start basicInfoWrap flex-col">
          <span>
            (주)디엔에이클라우드 I 대표이사 : 이병수 I 사업자등록번호 :
            714-87-00584 I E-MAIL : sales@dnacloud.co.kr
            <br />
            서울특별시 성동구 성수일로 99 서울숲AK밸리 506호 I 상담문의 : 02-6406-6100
          </span>
        </div>
        <div className="linkList justify-center tab:justify-start flex-row align-center gap-16">
          <Link to={'/company'}>
            <span>회사소개</span>
          </Link>
          <div className="divide"></div>
          <Link to={'/servicepolicy'}>
            <span>서비스이용약관</span>
          </Link>
          <div className="divide"></div>
          <Link to={'/privacy'}>
            <span>개인정보처리방침</span>
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
